import { smb_fetch, getAgpApiUrl, getAgsApiUrl } from '@/api/operator/fetch';
import { hasFeatureFlag } from '@/services';

/**
 * 获取员工列表
 * @return
 */
export const getEmployeeList = (data) => {
  const url = getAgpApiUrl('employee', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 删除员工
 * @return
 */
export const deleteEmployee = (data, isShowError = false) => {
  const url = getAgpApiUrl('employee', 'delete');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 删除员工
 * @return
 */
export const checkDeleteEmployee = (data, isShowError = false) => {
  const url = getAgpApiUrl('employee', 'check_delete');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 新增员工
 * @return
 */
export const createEmployee = (data) => {
  const url = getAgpApiUrl('employee', 'store');
  const params = $.extend(
    true,
    {
      method: 'POST',
      timeout: 0,
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 员工重新入职
 * @return
 */
export const reEntryEmployee = (data) => {
  const url = getAgpApiUrl('employee', 're_entry');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 员工离职
 * @return
 */
export const leaveEmployee = (data) => {
  const url = getAgpApiUrl('employee', 'leave');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取员工权限列表
 * @return
 */
export const getPermissionsList = (data) => {
  const url = getAgpApiUrl('employee', 'get_permissions');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取销售职务列表
 * @return
 */
export const getPostList = (data) => {
  const url = getAgpApiUrl('organization', 'get_title_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params, false);
};

/**
 * 获取销售所属架构列表
 * @return
 */
export const getOrganizationList = (data, isCache = true) => {
  const url = getAgpApiUrl('organization', 'get_tree');
  const params = $.extend(
    true,
    {
      method: 'POST',
      isCache,
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取销售呼叫中心列表
 * @return
 */
export const getAgsCallList = (data, agencyId) => {
  const url = getAgsApiUrl('agency', agencyId);
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 获取坐席详情
 * @return
 */
export const getAgsSeatDetails = (data) => {
  const url = getAgsApiUrl('employee', 'getSeatUseDetails');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 获取坐席角色
 * @return
 */
export const getAgsSeatRolesList = (data) => {
  const url = getAgsApiUrl('employee', 'seat/roles');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 获取坐席技能
 * @return
 */
export const getAgsSeatSkillList = (data, callCenterId) => {
  const url = getAgsApiUrl('employee/seat/skill', callCenterId);
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 获取是否存在未交接的任务
 * @return
 * @id userId
 */
export const getHandoverTask = (data, id) => {
  const url = getAgsApiUrl('employee/get-batch-transfer-detail-for-json', id);
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 获取角色列表
 * @return
 */
export const getRoleList = (data) => {
  const url = getAgpApiUrl('organization', 'get_role_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 获取籍贯地址
 * @return
 */
export const getAgsArea = (data) => {
  const url = getAgpApiUrl('user', 'area');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 删除 人户关系
 * @return
 */
export const deleteAdvertiser = (data) => {
  const url = getAgpApiUrl('user_responded_advertiser', 'delete');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取人户关系 列表
 * @return
 */
export const getAdvertiserList = (data) => {
  const url = getAgpApiUrl('operator', 'get_bind_advertiser_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 新增人户关系
 * @return
 */
export const setAdvertiserList = (data) => {
  const url = getAgpApiUrl('user_responded_advertiser', 'store');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取服务商下的所有广告主
 * @return
 */
export const getUidAndAppidList = (data) => {
  const url = getAgpApiUrl('advertiser', 'get_uid_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

export const getOperatorList = (data) => {
  const url = getAgpApiUrl('operator', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_list' : 'get_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取员工绑定的广告主
 * @param user_id
 * @return
 */
export const getBindAdvertiserList = (data) => {
  const url = getAgpApiUrl('operator', 'get_bind_advertiser_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, true);
};

/**
 * 获取
 * @param user_id
 * @return
 */
export const getAgsAgencyID = (data) => {
  const url = getAgsApiUrl('agency', 'company');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 修改角色
 * @param user_id
 * @return
 */
export const rolesBind = (data) => {
  const url = getAgsApiUrl('employee', 'roles/bind');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 批量转组
 * @param user_id
 * @return
 */
export const batchTransferGroup = (data) => {
  const url = getAgpApiUrl('employee', 'batch_transfer');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 清空广告主
 * @param user_id
 * @return
 */
export const deleteAll = (data) => {
  const url = getAgpApiUrl('user_responded_advertiser', 'deleteAll');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 批量上传个人简介
 * @return
 */
export const batchUploadPersonalInfo = (data) => {
  const url = getAgpApiUrl('user', 'batch_upload_personal_info');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

// 转移广告主
export function transferAdvertiser(data) {
  const url = getAgpApiUrl('user_responded_advertiser', 'transfer');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
}

/**
 * 批量上传头像
 * @return
 */
export const batchUploadProfilePhoto = (data) => {
  const url = getAgpApiUrl('user', 'batch_upload_profile_photo');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 批量上传企微二维码
 * @return
 */
export const batchUploadWecomQrcode = (data) => {
  const url = getAgpApiUrl('user', 'batch_upload_wecom_qrcode');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 释放坐席
 * @return
 */
export const releaseEmployeeSeat = (data, user_id) => {
  const url = getAgsApiUrl('employee', 'seat', user_id, 'release');
  console.log(user_id);
  console.log(url);
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 解绑企微
 * @return
 */
export const unbindWechatWork = (data) => {
  const url = getAgsApiUrl('employee', 'wechat-work/unbind');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    data,
  );
  return smb_fetch(url, params, false, false);
};

/**
 * 解绑运营企微
 * @return
 */
export const unbindOperationWechatWork = (data) => {
  const url = getAgpApiUrl('employee', 'unbind_corp_wechat');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    data,
  );
  return smb_fetch(url, params, true, false);
};

/**
 * 获取营销服务市场一键授权状态
 * @return
 */
export const getIsvAuthStatus = (data, isShowError = false) => {
  const url = getAgpApiUrl('isv', 'app_auto_activation_auth/show_auth');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 营销服务市场一键授权
 * @return
 */
export const oneClickIsvAuth = (data) => {
  const url = getAgpApiUrl('isv', 'app_auto_activation_auth/add');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 忽略营销服务市场一键授权
 * @return
 */
export const ignoreIsvAuth = (data) => {
  const url = getAgpApiUrl('isv', 'app_auto_activation_auth/ignore');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取权限列表
 * @return
 */
export const getAllPermissionList = (data) => {
  const url = getAgpApiUrl('orbac_agency_service', 'permission/list');
  return smb_fetch(url, {
    method: 'POST',
    data,
  }, true, false);
};

/**
 * 新增自定义角色
 * @return
 */
export const createCustomRole = (data) => {
  const url = getAgpApiUrl('orbac_agency_service', 'role/add');
  return smb_fetch(url, {
    method: 'POST',
    data,
  }, true, false);
};
